import { combineReducers } from 'redux'

import partnershipCertificateDialogReducer from '../../containers/PartnershipCertificateDialog/PartnershipCertificateDialog.reducer'
import registerWizardReducer from '../../containers/RegisterWizard/RegisterWizard.reducer'
import taxesKeyAuthReducer from '../../containers/TaxesKeyAuth/TaxesKeyAuth.reducer'
import uniquePassAuthReducer from '../../containers/UniquePassAuth/UniquePassAuth.reducer'
import unsubscribeReducer from '../../containers/Unsubscribe/Unsubscribe.reducer'
import authenticationProviderReducer from '../../containers/AuthenticationProvider/AuthenticationProvider.reducer'

export default combineReducers({
  partnershipCertificateDialog: partnershipCertificateDialogReducer,
  registerWizard: registerWizardReducer,
  taxesKeyAuth: taxesKeyAuthReducer,
  uniquePassAuth: uniquePassAuthReducer,
  unsubscribe: unsubscribeReducer,
  authentication: authenticationProviderReducer
})
